import React, { useState } from 'react';
import { Button, Modal } from '@maxtropy/components';
import { FullscreenOutlined } from '@ant-design/icons';
import { HlsVideo } from '@/components/RecorderPreview';
import styles from './index.module.scss';

interface MonitorCardProps {
  name: string;
  url?: string;
  code?: string;
}

const MonitorCard: React.FC<MonitorCardProps> = ({ name, url, code }) => {
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  return (
    <div className={styles.videoCard}>
      {<HlsVideo src={url} code={code} height="100%" minHeight={150} />}
      <div className={styles.videoCardActionInfo}>
        <span>{name || '--'}</span>
        <Button type="link" icon={<FullscreenOutlined />} onClick={() => setIsFullScreen(true)}>
          全屏
        </Button>
      </div>
      {isFullScreen && (
        <Modal
          open={isFullScreen}
          title={name}
          size="big"
          onCancel={() => setIsFullScreen(false)}
          footer={null}
          destroyOnClose
          maskClosable={false}
        >
          {<HlsVideo src={url} code={code} height="100%" minHeight={500} />}
        </Modal>
      )}
    </div>
  );
};

export default MonitorCard;
